import { isSuperAdmin, useCurrentUserRole } from '@components/Common/Utils/roles';
import TimelineOutlinedIcon from '@mui/icons-material/TimelineOutlined';
import { Button } from '@mui/material';
import React from 'react';
import { Link } from 'react-router-dom';

/**
 * "View activity" on a person's workspace: the Activity monitor, filtered to them.
 *
 * Super Admin only, as the monitor is; for anyone else it renders nothing rather than a link to
 * a tab they would be bounced from.
 */
const ViewActivityButton: React.FC<{ actorId?: string | null }> = ({ actorId }) => {
  const role = useCurrentUserRole();
  if (!actorId || !isSuperAdmin(role)) return null;
  return (
    <Button
      size="small"
      variant="outlined"
      startIcon={<TimelineOutlinedIcon fontSize="small" />}
      component={Link}
      to={`/dashboard/activity?${new URLSearchParams({ actor: actorId }).toString()}`}
    >
      View activity
    </Button>
  );
};

export default ViewActivityButton;
